module.exports = "query trainingPaths {\n  entries(section: [\"trainings\"], limit: 1) {\n    id\n  }\n}"